/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Translation_Options_LabelInputs */

const en_merge_event_group_translation_options_label = /** @type {(inputs: Merge_Event_Group_Translation_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translation Options`)
};

const fr_merge_event_group_translation_options_label = /** @type {(inputs: Merge_Event_Group_Translation_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options de traduction`)
};

const de_merge_event_group_translation_options_label = /** @type {(inputs: Merge_Event_Group_Translation_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzungsoptionen`)
};

const it_merge_event_group_translation_options_label = /** @type {(inputs: Merge_Event_Group_Translation_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni di traduzione`)
};

const ru_merge_event_group_translation_options_label = /** @type {(inputs: Merge_Event_Group_Translation_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Параметры перевода`)
};

const es_merge_event_group_translation_options_label = /** @type {(inputs: Merge_Event_Group_Translation_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones de traducción`)
};

const zh_cn2_merge_event_group_translation_options_label = /** @type {(inputs: Merge_Event_Group_Translation_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻译选项`)
};

const ja_merge_event_group_translation_options_label = /** @type {(inputs: Merge_Event_Group_Translation_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳オプション`)
};

const hi_merge_event_group_translation_options_label = /** @type {(inputs: Merge_Event_Group_Translation_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद विकल्प`)
};

const pt_pt2_merge_event_group_translation_options_label = /** @type {(inputs: Merge_Event_Group_Translation_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções de tradução`)
};

/**
* | output |
* | --- |
* | "Translation Options" |
*
* @param {Merge_Event_Group_Translation_Options_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_translation_options_label = /** @type {((inputs?: Merge_Event_Group_Translation_Options_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Translation_Options_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_event_group_translation_options_label(inputs)
	if (locale === "de") return de_merge_event_group_translation_options_label(inputs)
	if (locale === "it") return it_merge_event_group_translation_options_label(inputs)
	if (locale === "ru") return ru_merge_event_group_translation_options_label(inputs)
	if (locale === "es") return es_merge_event_group_translation_options_label(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_event_group_translation_options_label(inputs)
	if (locale === "ja") return ja_merge_event_group_translation_options_label(inputs)
	if (locale === "hi") return hi_merge_event_group_translation_options_label(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_event_group_translation_options_label(inputs)
	return en_merge_event_group_translation_options_label(inputs)
});